import axios from "../../../lib/axios";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import { QData } from "../../../types/basic-type-list";
import { TResponse, TResponseWithQData } from "../../../types/common";
import { IProduct, ProductFormValues } from "../../../types/api/product";
import { AxiosResponse } from "axios";

export async function productList(
  qData: QData & { artistId?: string; search?: string }
): Promise<AxiosResponse<TResponseWithQData<IProduct[]>>> {
  return axios.get(API_ENDPOINTS.PRODUCT_LIST, { params: qData });
}

export async function productDetail(
  id: string
): Promise<AxiosResponse<TResponse<IProduct>>> {
  return axios.get(`${API_ENDPOINTS.PRODUCT_DETAIL}/${id}`);
}

export async function createProduct(
  data: ProductFormValues
): Promise<AxiosResponse<TResponse<IProduct>>> {
  return axios.post<TResponse<IProduct>>(API_ENDPOINTS.PRODUCT_CREATE, data);
}

export async function updateProduct({
  id,
  data,
}: {
  id: string;
  // Partial, not ProductFormValues - the backend validation is all-optional
  // partial-update (confirmed against productValidations.update), and the
  // quick "Approve" action in the list only ever sends {status, pendingApproval}.
  data: Partial<ProductFormValues>;
}): Promise<AxiosResponse<TResponse<IProduct>>> {
  return axios.put<TResponse<IProduct>>(`${API_ENDPOINTS.PRODUCT_UPDATE}/${id}`, data);
}

// Merges any staged product/variant edits (pendingChanges) onto the live
// fields and publishes them - distinct from a plain status:true PUT, which
// would leave an artist's staged edit stranded unapplied. See
// ProductService.approveProduct.
export async function approveProduct(
  id: string
): Promise<AxiosResponse<TResponse<IProduct>>> {
  return axios.patch<TResponse<IProduct>>(`${API_ENDPOINTS.PRODUCT_UPDATE}/${id}/approve`);
}

export async function deleteProduct(
  id: string
): Promise<AxiosResponse<TResponse<null>>> {
  return axios.delete<TResponse<null>>(`${API_ENDPOINTS.PRODUCT_DELETE}/${id}`);
}
